import ResourceGet from '../../resource/get';

const AssetsGet = () => {

      return(
        <div>
          <ResourceGet resource="cabins" name="Cabins" />
        </div>
      )

}

export default AssetsGet;